/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Google_Sign_InInputs */

const en_common_sign_google_sign_in = /** @type {(inputs: Common_Sign_Google_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with Google`)
};

const zh_common_sign_google_sign_in = /** @type {(inputs: Common_Sign_Google_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 Google 登录`)
};

/**
* | output |
* | --- |
* | "Sign in with Google" |
*
* @param {Common_Sign_Google_Sign_InInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_google_sign_in = /** @type {((inputs?: Common_Sign_Google_Sign_InInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Google_Sign_InInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_google_sign_in(inputs)
	return zh_common_sign_google_sign_in(inputs)
});
export { common_sign_google_sign_in as "common.sign.google_sign_in" }